
import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Carousel from 'react-bootstrap/Carousel';

import rel4 from '../images/imagesHome/HomePage/NewReleases/GochungTso.webp';

import rel2 from '../images/imagesHome/HomePage/NewReleases/VasudharaTal.webp'

import rel3 from '../images/imagesHome/HomePage/NewReleases/ShakoCho.webp';


import rel1 from '../images/imagesHome/HomePage/NewReleases/KhangchungTso.webp';
import rel5 from '../images/imagesHome/HomePage/NewReleases/Safed.webp';
import rel7 from '../images/imagesHome/HomePage/NewReleases/MasarTal.webp'
import rel6 from '../images/imagesHome/HomePage/NewReleases/Saraswathi.webp'


import url from "./urls"

class Bulletin extends Component {
  constructor(props) {
    super(props);

  }
 
  render() {

    return (
      <Container className=" d-flex flex-column " >
        <Row>
          <Col>  
                <Container fluid className="big-title" > 
                
                <h2 className="blue-text1"> Bulletins <span className="red-text1"> & </span> Reports</h2>
                </Container>
          </Col>
          </Row>
          <Row>




            <Col md={6} lg={6} xs={12} sm={12} xl={6} >  <p className='bulletinrelease'> NEW RELEASES</p>
              <Carousel slide={false} indicators={false}  nextLabel="" 
  prevLabel="" className="bulletinCarousel">
                      <Carousel.Item>
                  <a href={url.KhangchungTso} target="_blank" rel="noopener noreferrer">
                    <img 
                      src={rel1} 
                      alt="image1" 
                      className="img-fluid" 
                      style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}
                    />
                  </a>
                </Carousel.Item>
                <Carousel.Item>
                 <a href= {url.VasudharaTal} target="_blank" rel="noopener noreferrer">
                 <img src={rel2} alt="image2" className="img-fluid" style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}  />
                 </a>
    
                </Carousel.Item>
                <Carousel.Item>
                 <a href= {url.Shakocho} target="_blank" rel="noopener noreferrer">
                 <img src={rel3} alt="image3"className="img-fluid" style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}  />
                 </a>
    
                </Carousel.Item>
                <Carousel.Item>
                 <a href= {url.GochungTso} target="_blank" rel="noopener noreferrer">
                 <img src={rel4} alt="image4" className="img-fluid" style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}  />
                 </a>
    
                </Carousel.Item>

                <Carousel.Item>
                 <a href=  {url.Safed} target="_blank" rel="noopener noreferrer">
                 <img src={rel5} alt="image5" className="img-fluid" style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}  />
                 </a>
    
                </Carousel.Item>


                <Carousel.Item>
                 <a href= {url.Saraswati} target="_blank" rel="noopener noreferrer">
                 <img src={rel6} alt="image7" className="img-fluid" style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}  />
                 </a>
    
                </Carousel.Item>
                <Carousel.Item>
                 <a href= {url.MasarTal} target="_blank" rel="noopener noreferrer">
                 <img src={rel7} alt="image6" className="img-fluid" style={{maxWidth: '100%', height: 'auto', maxHeight: '50vh', objectFit: 'contain'}}  />
                 </a>
    
                </Carousel.Item>

               </Carousel>
           </Col>
          <Col  md={6} lg={6} xs={12} sm={12} xl={6}>
            <Container fluid className='archives'>
            <p className="bulletinrelease">ARCHIVES</p>
            <div className="scrollableList">

            <p className='bulletinyear'> 2025</p>
            <ul className='bulletinList'>
            {/* <li>
                <a href= {url.SouthLhonak} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of South Lhonak Glacial Lake in Brahmaputra River Basin</a>

              </li>
              <li>
                <a href= {url.Gurudongmar} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Gurudongmar Glacial Lake in Brahmaputra River Basin</a>

              </li> 
              <li>
              <a href= {url.Kedartal} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Kedar Tal Glacial Lake in Ganga River Basin</a>

            </li>
             */ }

              <li>
                <a href= {url.SouthLhonak} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of SouthLhonak Glacial Lake in Brahmaputra River Basin</a>

              </li>
               <li>
                <a href= {url.Kedartal} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Kedartal Glacial Lake in Ganga River Basin</a>

              </li>
            <li>
                <a href= {url.KhangchungTso} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Khangchung Tso Glacial Lake in Brahmaputra River Basin</a>

              </li>
            <li>
                <a href= {url.VasudharaTal} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of  Vasudhara Tal Glacial Lake in Ganga River Basin</a>

              </li>
            <li>
                <a href= {url.Shakocho} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of  Shakocho Glacial Lake in Brahmaputra River Basin</a>

              </li>
              
        
              </ul>

            <p className='bulletinyear'> 2024</p>
            <ul className='bulletinList'>             
              <li>
                <a href= {url.GochungTso} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Gochung Tso Glacial Lake in Brahmaputra River Basin</a>

              </li>
             
             
              <li>
                <a href= {url.Safed} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Safed Glacial Lake in Ganga River Basin</a>

                </li>
             
              
              <li>
                <a href= {url.Katkar} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Katkar Glacial Lake in Indus River Basin</a>
               
                </li>
               
              
              <li>
                <a href= {url.Saraswati} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Saraswati Glacial Lake in Ganga River Basin</a>
              </li>
              <li>
                <a href= {url.MasarTal} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Masar Tal Glacial Lake in Ganga River Basin</a>
              </li>
              <li>
                <a href= {url.SamudraTapu} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of SamudraTapu Glacial Lake in Indus River Basin</a>
              </li>
             
              <li>
                <a href= {url.Mundiksar} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of  Mundiksar Glacial Lake in Indus River Basin</a>
              </li>
              <li>
                <a href= {url.Suru} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Suru Glacial Lake in Indus River Basin</a>
              </li>
    
              
    
            </ul>

            <p className='bulletinyear'> 2023</p>
            <ul className='bulletinList'>
            
            <li>
                <a href= {url.compendium} target="_blank" rel="noopener noreferrer" className='bulletinLink'>Compendium on GeoSpatial Hydro Products and services</a>
              </li>
              <li>
                <a href= {url.NHPNrsc} target="_blank" rel="noopener noreferrer" className='bulletinLink'>Flyer on GeoSpatial Hydro Products and services</a>
              </li>
              <li>
                <a href= {url.report_glof} target="_blank" rel="noopener noreferrer" className='bulletinLink'>Flyer on GLOF Risk Assessment of Ghepang Ghat Glacial Lake in Indus River Basin</a>
              </li>
              <li>
                <a href= {url.et_750} target="_blank" rel="noopener noreferrer" className='bulletinLink'>Actual Evapotranspiration - Flyer</a>
              </li>
           

              <li>
                <a href= {url.GhepangGhat} target="_blank" rel="noopener noreferrer" className='bulletinLink'>GLOF Risk Assessment of Ghepang Ghat Glacial Lake in Indus River Basin</a>
              </li>
    
              <li>
                <a href= {url.IHR_GlacialLake_Atlas} target="_blank" rel="noopener noreferrer" className='bulletinLink'>Glacial Lakes of Indian Himalayan River Basins </a>
              </li>
    
            </ul>
           
            <p className='bulletinyear'> 2022</p>
            <ul className='bulletinList'>
              <li>
                <a href= {url.glofbrahmaputraatlas_live} target="_blank" rel="noopener noreferrer" className='bulletinLink'>Glacial Lakes of Brahmaputra Basin</a>
              </li>
    
            </ul>

            <p className='bulletinyear'> 2021</p>
            <ul className='bulletinList'>
              <li>
              <a href= {url.glofgangaatlas_live} target="_blank" rel="noopener noreferrer"   className='bulletinLink'>Glacial Lake Atlas of Ganga Basin </a>
              </li>
    
            </ul>
            <p className='bulletinyear'> 2020</p>
            <ul className='bulletinList'>
                <li>
                  <a href= {url.glofindusatlas_live} target="_blank" rel="noopener noreferrer"  className='bulletinLink'>Glacial Lakes of Indus Basin</a>
                </li>
            
            </ul>
            </div>
    
      </Container>
      </Col>
      
     
      </Row>

      </Container>
      
    );
  }
}

export default Bulletin;